<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle [title]="'Displaying Vehicles of '+customerName" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Reg No.</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of vehicles; let i= index">
                <td>{{i + 1}}</td>
                <td>{{item.vehicleModel}}</td>
                <td>{{item.vehicleBrand}}</td>
                <td>{{item.regNumber}}</td>

                <td>
                  <button mat-button class="btn btn-primary" [matMenuTriggerFor]="menu">Menu</button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item [routerLink]="[item.userVehicleId,'trouble-codes']"
                            [queryParams]="{name:(item.vehicleBrand+'-'+item.vehicleModel+'-'+item.regNumber)}">Trouble
                      Codes</button>
                    <button mat-menu-item  [routerLink]="['../../','driving-alerts']"
                            [queryParams]="{name:(item.vehicleBrand+'-'+item.vehicleModel+'-'+item.regNumber),vehicleId:item.userVehicleId}">Driving
                      Alerts</button>
<!--                    <button mat-menu-item [routerLink]="['..','trips']"-->
<!--                            [queryParams]="{vehicleId:item.userVehicleId,-->
<!--                         vehicleName:(item.vehicleBrand+' '+item.vehicleModel+' '+item.regNumber),customerName:customerName}">Trips</button>-->
                  </mat-menu>

<!--                  <div class="dropdown mt-4 mt-sm-0" ngbDropdown>-->
<!--                    <a class="btn btn-light " ngbDropdownToggle>-->
<!--                      Menu <i class="mdi "></i>-->
<!--                    </a>-->
<!--                    <div class="dropdown-menu" ngbDropdownMenu>-->
<!--                      <a class="dropdown-item p-2" ngbDropdownItem href="javascript: void(0);"-->
<!--                         [routerLink]="[item.userVehicleId,'trouble-codes']"-->
<!--                         [queryParams]="{name:(item.vehicleBrand+'-'+item.vehicleModel+'-'+item.regNumber)}">Trouble-->
<!--                        Codes</a>-->
<!--                      <a class="dropdown-item p-2" ngbDropdownItem href="javascript: void(0);"-->
<!--                         [routerLink]="['../../','driving-alerts']"-->
<!--                         [queryParams]="{name:(item.vehicleBrand+'-'+item.vehicleModel+'-'+item.regNumber),vehicleId:item.userVehicleId}">Driving-->
<!--                        Alerts</a>-->
<!--                      <a class="dropdown-item p-2" ngbDropdownItem href="javascript: void(0);" [routerLink]="['..','trips']"-->
<!--                         [queryParams]="{vehicleId:item.userVehicleId,-->
<!--                         vehicleName:(item.vehicleBrand+' '+item.vehicleModel+' '+item.regNumber),customerName:customerName}">Trips</a>-->
<!--                    </div>-->
<!--                  </div>-->

                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
